<template>
  <div class="pagination background-fff">
    <el-pagination background @current-change="currentChange" @prev-click="currentChange" @next-click="currentChange" @size-change="sizeChange" :layout="layout?layout:'total, sizes, prev, pager, next, jumper'" :page-sizes="[10, 20, 30, 40,100,200]" :total="total" :page-size="pageSize" :current-page.sync="current"></el-pagination>
  </div>
</template>
<script>
let _this
export default {
  props: {
    total: {
      type: Number,
      default: 100,
    },
    layout: {
      type: String,
      default: '',
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      sIndex: 0,
      current:1,
    }
  },
  watch: {
    currentPage: {
      handler(value) {
       this.current = this.currentPage
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    currentChange(e) {
      this.$emit('currentChange', e)
    },
    sizeChange(e) {
      this.$emit('sizeChange', e)
    },
  },
}
</script>
<style lang='less'>
</style>



// WEBPACK FOOTER //
// src/components/parts/h-pagination.vue